module.exports = __webpack_public_path__ + "static/about-1-4ddaf86596bdb356fd6b659be774e804.jpg";